// Landing pages for Stripe Connect onboarding (puttr-api src/lessons.js sends
// coaches here as return_url / refresh_url). The coach started in the app, so
// the only job is to send them back.
import React from 'react';
import { useLocation } from 'react-router-dom';
import { ReactComponent as Logo } from '../images/logo_header.svg';
import OpenInApp from './common/OpenInApp';
import './games/GameView.css';

export default function StripeReturn() {
  const { pathname } = useLocation();
  const refreshed = pathname.endsWith('/refresh');

  return (
    <div className="darkPage">
      <div className="topBar">
        <Logo className="logo" />
      </div>
      <div className="page" style={{ paddingTop: 40 }}>
        <div className="gcard center">
          <div className="bold" style={{ fontSize: 18 }}>
            {refreshed ? 'That Stripe link expired' : 'Payouts are set up'}
          </div>
          <div className="muted" style={{ marginTop: 8, lineHeight: 1.5 }}>
            {refreshed
              ? 'Head back to the Puttr app and tap Set up payouts again to get a fresh link.'
              : 'You can close this page and head back to the Puttr app to finish setting up lessons.'}
          </div>
          <div style={{ marginTop: 18 }}>
            <OpenInApp path="open" label="Back to the Puttr app" />
          </div>
        </div>
      </div>
    </div>
  );
}
